import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LiteSessionActivity from '../LiteSessionActivity';
import styles from './ActivityRouteGuard.module.scss';

const ACTIVTY_ROUTE = '/activity';

const ActivityRouteGuard = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const isLiteRoute = new URLSearchParams(search).get('lite');
  const { data: activityData } = useSelector(state => state.activity);

  const canAccess = pathname === ACTIVTY_ROUTE && isLiteRoute;

  if (!canAccess) {
    navigate('/');
    return null;
  }

  if (!activityData || !activityData.activities.length) {
    return <div className={styles.noDataMessage}>No activity found</div>;
  }

  return <LiteSessionActivity />;
};

export default ActivityRouteGuard;
